import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:section/:slug',
      name: 'article',
      props: true,
      // route level code-splitting
      // this generates a separate chunk (article.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "article" */ './views/Article.vue')
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/ciencia-trans',
      name: 'cienciatrans',
      component: () => import(/* webpackChunkName: "cienciatrans" */ './views/pages/CienciaTrans.vue')
    },
    {
      path: '/salud-trans',
      name: 'saludtrans',
      component: () => import(/* webpackChunkName: "saludtrans" */ './views/pages/SaludTrans.vue')
    },
    {
      path: '/chile-trans',
      name: 'chiletrans',
      component: () => import(/* webpackChunkName: "chiletrans" */ './views/pages/ChileTrans.vue')
    },
    {
      path: '/infancia-trans',
      name: 'infanciatrans',
      component: () => import(/* webpackChunkName: "infanciatrans" */ './views/pages/InfanciaTrans.vue')
    },
    {
      path: '/avance-trans',
      name: 'avancetrans',
      component: () => import(/* webpackChunkName: "avancetrans" */ './views/pages/AvanceTrans.vue')
    },
    {
      path: '/experiencias-trans',
      name: 'experienciastrans',
      component: () => import(/* webpackChunkName: "experienciastrans" */ './views/pages/ExperienciasTrans.vue')
    },
    {
      path: '/la-lengua-muy-bien-gracias',
      name: 'lalenguamuybiengracias',
      component: () => import(/* webpackChunkName: "lalenguamuybiengracias" */ './views/pages/LaLenguaMuyBienGracias.vue')
    },
    {
      path: '/activista',
      name: 'activista',
      component: () => import(/* webpackChunkName: "activista" */ './views/pages/Activista.vue')
    },
    {
      path: '/el-derecho-a-las-identidades-sexuales',
      name: 'elderechoalasidentidadessexuales',
      component: () => import(/* webpackChunkName: "elderechoalasidentidadessexuales" */ './views/pages/ElDerechoALasIdentidadesSexuales.vue')
    },
    {
      path: '/mi-transicion',
      name: 'mitransicion',
      component: () => import(/* webpackChunkName: "mitransicion" */ './views/pages/MiTransicion.vue')
    },
    {
      path: '/podcast-salud',
      name: 'podcastsalud',
      component: () => import(/* webpackChunkName: "podcastsalud" */ './views/pages/PodcastSalud.vue')
    },
    {
      path: '/podcast-lig',
      name: 'podcastlig',
      component: () => import(/* webpackChunkName: "podcastlig" */ './views/pages/PodcastLig.vue')
    }
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return window.scrollTo({
        top: document.querySelector(to.hash).offsetTop - 100,
        behavior: 'smooth'
      });
    } else {
      return setTimeout(() => {
        window.scrollTo({
          top: 0,
          // behavior: 'smooth'
        })
      }, 300)
    }
  }
})
